import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateOpenShiftFormErrors", function updateOpenShiftFormErrors(errorCount: number) {
    shiftEditorViewState().openShiftFormErrors = errorCount;
});